import { IReading } from "../models/meterReading/meterReading.types"
import {
  IRegister,
  IRegisterReadingFilters,
} from "../models/meterRegister/meterRegister.types"

export const getLatestRegisterReading = (
  register: IRegister,
  filters: IRegisterReadingFilters = {},
  getReadingBeforeLast?: boolean,
): IReading | undefined => {
  const { isSmart = false, areSystemReadsIncluded = false } = filters

  const reads = register.readings.filter((reading) => {
    const isRealReadOrSystemAccepted =
      areSystemReadsIncluded || !reading.isSystemReading

    const isSmartReadOrNonSmartAccepted = !isSmart || reading.isSmartReading

    return isRealReadOrSystemAccepted && isSmartReadOrNonSmartAccepted
  })

  if (reads.length) {
    reads.sort((a, b) => (a.date.isAfter(b.date) ? -1 : 1))
    return reads[getReadingBeforeLast ? 1 : 0]
  }
}
